import { combineReducers } from 'redux'

import biblioteca from 'app/store/reducers/ebooks/biblioteca.reducer'
import caminos from 'app/store/reducers/ebooks/caminos.reducer'
import caminos3ca from 'app/store/reducers/ebooks/caminos3ca.reducer'
import library from 'app/store/reducers/ebooks/library.reducer'
import texaselar from 'app/store/reducers/ebooks/texaselar.reducer'
import texaselar2E from 'app/store/reducers/ebooks/texaselar2e.reducer'
import texasslar from 'app/store/reducers/ebooks/texasslar.reducer'
import texasslar2E from 'app/store/reducers/ebooks/texasslar2e.reducer'

const EbooksReducer = combineReducers({
  library,
  biblioteca,
  caminos,
  caminos3ca,
  texaselar,
  texasslar,
  texaselar2E,
  texasslar2E,
})

export default EbooksReducer
